import { useQuery } from "@apollo/client";
import { TAXONOMY_CLIENT } from "../../../utils/consts";
import { CATEGORY_PRODUCT_COUNT_QUERY } from "./queries/categoryProductCountQuery";
import { NumberCard } from "../components/NumberCard";

export const ProductCountCard = (props: { leafCategoryIds: string[] }) => {
  const { data, loading } = useQuery(CATEGORY_PRODUCT_COUNT_QUERY, {
    variables: {
      categoryIds: props.leafCategoryIds,
    },
    skip: props.leafCategoryIds.length === 0,
    context: {
      clientName: TAXONOMY_CLIENT,
    },
  });

  return (
    <NumberCard
      id="product-count"
      isLoading={loading}
      count={data?.product.count || 0}
      title="Number of Products"
    />
  );
};
